
import Hero from './components/Hero';
import Services from './components/Services';
import CTA from './components/CTA';

export default function Logistics() {
  return (
    <div className="min-h-screen">
      <Hero />
      <Services />
      <CTA />
    </div>
  );
}
